import { useLocation, useNavigate } from 'react-router-dom';
import { Navigation as PolarisNavigation } from '@shopify/polaris';
import {
  HomeIcon,
  TargetIcon,
  HashtagIcon,
  ChartVerticalIcon,
  MegaphoneIcon,
  ImageIcon,
  ViewIcon,
  LiveIcon,
  SendIcon,
  ChartLineIcon,
  SettingsIcon,
  CreditCardIcon,
} from '@shopify/polaris-icons';
import { useTranslation } from '../i18n/LanguageContext';

export function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const t = useTranslation();

  return (
    <PolarisNavigation location={location.pathname}>
      <PolarisNavigation.Section
        items={[
          {
            url: '/',
            label: t.nav.dashboard,
            icon: HomeIcon,
            selected: location.pathname === '/',
            onClick: () => navigate('/'),
          },
          {
            url: '/google-ads',
            label: t.nav.googleAds,
            icon: TargetIcon,
            selected: location.pathname === '/google-ads',
            onClick: () => navigate('/google-ads'),
          },
          {
            url: '/meta',
            label: t.nav.meta,
            icon: HashtagIcon,
            selected: location.pathname === '/meta',
            onClick: () => navigate('/meta'),
          },
          {
            url: '/ga4',
            label: 'GA4',
            icon: ChartVerticalIcon,
            selected: location.pathname === '/ga4',
            onClick: () => navigate('/ga4'),
          },
          {
            url: '/tiktok',
            label: 'TikTok',
            icon: MegaphoneIcon,
            selected: location.pathname === '/tiktok',
            onClick: () => navigate('/tiktok'),
          },
          {
            url: '/pinterest',
            label: 'Pinterest',
            icon: ImageIcon,
            selected: location.pathname === '/pinterest',
            onClick: () => navigate('/pinterest'),
          },
          {
            url: '/snapchat',
            label: 'Snapchat',
            icon: ViewIcon,
            selected: location.pathname === '/snapchat',
            onClick: () => navigate('/snapchat'),
          },
          {
            url: '/events',
            label: 'Live Events',
            icon: LiveIcon,
            selected: location.pathname === '/events',
            onClick: () => navigate('/events'),
          },
          {
            url: '/webhooks',
            label: 'Webhooks',
            icon: SendIcon,
            selected: location.pathname === '/webhooks',
            onClick: () => navigate('/webhooks'),
          },
          {
            url: '/analytics',
            label: 'Analytics',
            icon: ChartLineIcon,
            selected: location.pathname === '/analytics',
            onClick: () => navigate('/analytics'),
          },
          {
            url: '/billing',
            label: t.nav.billing,
            icon: CreditCardIcon,
            selected: location.pathname === '/billing',
            onClick: () => navigate('/billing'),
          },
          {
            url: '/settings',
            label: t.nav.settings,
            icon: SettingsIcon,
            selected: location.pathname === '/settings',
            onClick: () => navigate('/settings'),
          },
        ]}
      />
    </PolarisNavigation>
  );
}
